import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import './Cancel.css';

const Cancel = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const timer = setTimeout(() => {
      navigate("/member");
    }, 3000); // Redirect after 3 seconds

    return () => clearTimeout(timer);
  }, [navigate]);

  return (
    <div className="cancel-container">
      <h1>Your Purchase Has Been Cancelled!</h1>
    </div>
  );
};

export default Cancel;
